import React from 'react';
import { Modal, List, Button, WhiteSpace, WingBlank, Icon } from 'antd-mobile';
import './index.css'
import axios from 'axios';
import userRequest, { userApi } from 'common/request';

class FaceIdentify extends React.Component {
    constructor(props){
        super(props);
        this.state={
            title:'人脸身份认证',
            permission: '',
            idCardNum: '',
            idName:  '',
            modal1: false,
            modal2: false,
            left: {},
            right: {},
            leftCover: {},
            rightCover: {},
            count: ''
        }
    }

    showModal = key => (e) => {
        // e.preventDefault(); // 修复 Android 上点击穿透
        this.setState({
            [key]: true,
        });
    }

    onClose = key => () => {
        this.setState({
          [key]: false,
        });
    }

    getCookie(name){
        let arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)")
        if (arr = document.cookie.match(reg)) return unescape(arr[2])
        else return null
    }

    jumpTo() {
        let token = this.getCookie('_token')
        let pattern=/{i:\d+;s:\d+:"_token";i:\d+;s:\d+:"(.+?)";}/
        token = pattern.exec(decodeURIComponent(token))
        token = token?`${token[1]}`: ''
      
        let ua = navigator.userAgent.toLowerCase();
		let isWeixin = ua.indexOf('micromessenger') != -1;
        let params= isWeixin ? {  'taskid': 'vvasdfxawzs', 'redirect': window.location.href, 'type': 'wechat'} : {  'taskid': 'vvasdfxawzs',
        'redirect': window.location.href}
        
        return axios({
            method: 'get',
            url: userApi.firstIdentify,
            params: params,
            timeout: 10000,
            headers: {
               'Authorization': `bearer ${token}`
            }
        }).then(response => {
            console.log(response)
            if(response.response !== undefined && (response.response.status !== 200 || 
                response.response.status !== 304 || response.response.status !== 400)) {
                alert(response.response.data.msg)
            }

            if (response !== undefined && ((response.status === 200 || response.status === 304 || response.status === 400))) {
                // return response.data // 直接返回http response响应的data,此data会后端返回的数据数据对象，包含后端自定义的code,message,data属性
                if(response.data.code == 200 && response.data.params && response.data.params.length > 0) {
                    if(localStorage.getItem('userinfo') !== null){
                        localStorage.removeItem('userinfo');
                    }
                    console.log(window.location.href)
                    window.location = response.data.params
                }
            }
        }).catch(err => {
            alert(err)
        })
    }

    async componentWillMount() {
        await userRequest.get( userApi.userInfo).then(res => {
            if(res.params !== undefined) {
                this.setState(() => {return {idName: res.params.realname}})
                this.setState(() =>{return {idCardNum: res.params.SFZH}})
            }
        }).catch(err => {})
    }

    render() {
        return (
            <Modal
            visible={this.state.modal1}
            transparent
            maskClosable={false}
            onClose={this.onClose('modal1')}
            title="人脸身份认证"
            style={{  height: '99%',
                width: '100%',
                position: 'absolute',
                top: '-5px'}}
            >
            <div style={{ height: '90%', overflow: 'scroll' }}>
                <div className="tips">
                    <span className="des-title">温馨提示：</span>
                    <span className="tips-text">
                        1、为确认培训有效性，进入平台前，您需要进行人脸识别身份认证，确认为本人进行学习。
                    </span>
                    <span className="tips-text">
                        2、人脸识别认证只能使用居民身份证，认证前请先确保身份证号无误。
                    </span>
                    <span className="tips-text">
                        3、本次认证结果很重要，请认真对待。
                    </span>
                </div>
                <div className="condition">
                    <div className="condition-img">
                        <div>
                            <div className="condition-block">
                                <img className="confirm-img"
                                src={require('./image/确认.png')}></img>
                                <img src={require('./image/手机.png')}></img>
                            </div>
                            <div className="condition-text">正对手机</div>
                        </div>
                        <div>
                            <div className="condition-block">
                            <img className="confirm-img"
                                src={require('./image/确认.png')}></img>
                            <img src={require('./image/灯泡.png')}></img>
                            </div>
                            <div className="condition-text">光线充足</div>
                        </div>
                        <div>
                            <div className="condition-block">
                            <img className="confirm-img"
                                src={require('./image/确认.png')}></img>
                                <img src={require('./image/时钟.png')}></img>
                            </div>
                            <div className="condition-text">放慢动作</div>
                        </div>
                    </div>
                    <div className="portrait">
                        <img src={require('./image/头像.png')}></img>
                        <span className="person-id">{this.state.idCardNum}</span>
                        <span className="person-id">{this.state.idName}</span>
                        {/* <IdentifyModal ref={e => this.child = e}></IdentifyModal> */}
                        {/* <button class="submit-identify" onClick={() => this.child.showModal('modal1')()}>开始人脸识别</button> */}
                        <Button className="submit-identify" 
                        onClick={() => this.jumpTo()}>开始人脸识别</Button>
                    </div>
                </div>
            </div>
            </Modal>
        )
    }
}

export default FaceIdentify;
